var lodash = require("lodash");
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { Injectable, Injector, NgModuleFactory, OnDestroy, Type, ValueProvider } from "@angular/core";
import { TabMetadata, FormContainerModel } from "./form-container-model";
import { VoucherKindInfo } from "../../../../sepidz-web-framework/src/lib/models/datatransfer.model";
import { takeUntil } from "rxjs/operators";
import { ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { TranslateService } from "@ngx-translate/core";

export interface ITab {
  id?: string;
  icon?: string;
  title: string;
  VoucherKindId?: number;
  responsive: boolean;
  isCloseable: boolean;
  active: boolean;
  componentType: Type<any>;
  component: any;
  modulePath?: any;
  moduleFactory?: any;
  injector: Injector;
  data?: ValueProvider[];
  hasbadge: boolean;
  BookMark: boolean;
}
export function guid() {
  return "xxxxxx4xyx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export interface IComponent {
  hasbadge: boolean;
}
@Injectable({ providedIn: "root" })
export class TabularService implements OnDestroy {
  ngUnsubscribe = new Subject<void>();
  public tabItemSubject: BehaviorSubject<ITab[]>;
  public tabItemOnClosing: BehaviorSubject<string>;
  public tabItemOnCanClosing: BehaviorSubject<string>;
  public tabItemActive: BehaviorSubject<string>;
  public selectedTabId: string;
  public tabItemOnClose: BehaviorSubject<string>;
  public tabItemonCloseAll: BehaviorSubject<boolean>;
  public tabItemonRefreshData: BehaviorSubject<string>;
  public tabItemOnCloseableIds: string[] = [];
  constructor(private injector: Injector, private sts: ShowToastrService, private translate: TranslateService) {
    this.tabItemOnClosing = new BehaviorSubject<string>("");
    this.tabItemOnCanClosing = new BehaviorSubject<string>("");
    this.tabItemSubject = new BehaviorSubject<ITab[]>([]);
    this.tabItemOnClose = new BehaviorSubject<string>("");
    this.tabItemonCloseAll = new BehaviorSubject<boolean>(false);
    this.tabItemActive = new BehaviorSubject<string>("");
    this.tabItemonRefreshData = new BehaviorSubject<string>("");
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    if (this.tabItemOnClosing) this.tabItemOnClosing.unsubscribe();
    if (this.tabItemSubject) this.tabItemSubject.unsubscribe();
    if (this.tabItemOnClose) this.tabItemOnClose.unsubscribe();
    if (this.tabItemonCloseAll) this.tabItemonCloseAll.unsubscribe();
    if (this.tabItemActive) this.tabItemActive.unsubscribe();
    if (this.tabItemonRefreshData) this.tabItemonRefreshData.unsubscribe();
  }
  get tabItems(): Observable<ITab[]> {
    return this.tabItemSubject.asObservable();
  }
  open(newTab: ITab) {
    this.openInternal(newTab);
  }
  setTabTitle(id: string, title: string) {
    this.tabItemSubject.getValue().forEach((x) => {
      if (x.id === id) x.title = title;
    });
  }
  openInternal(newTab: ITab) {
    const model = lodash.cloneDeep(newTab);
    model.data = model.data || [];
    if (!model.data) model.data = [];
    const metadata = <TabMetadata>{ id: guid() };
    if (newTab.VoucherKindId) {
      model.data.push({
        provide: VoucherKindInfo,
        useValue: <VoucherKindInfo>{ VoucherKindId: newTab.VoucherKindId },
      });
    }
    model.data.push({
      provide: FormContainerModel,
      useValue: <FormContainerModel>{ type: "Tab", metadata: metadata },
    });

    const newTabItem = <ITab>{
      id: metadata.id,
      responsive: newTab.responsive,
      title: newTab.title,
      icon: newTab.icon,
      componentType: newTab.componentType,
      isCloseable: newTab.isCloseable,
      active: newTab.active,
      modulePath: newTab.modulePath,
      hasbadge: newTab.hasbadge,
      injector: newTab.data
        ? Injector.create({
            providers: model.data,
            parent: this.injector,
          })
        : this.injector,
      data: newTab.data,
    };
    //newTabItem.component = this.getComponent(newTabItem);
    this.tabItemSubject.getValue().push(newTabItem);
    this.tabItemSubject.next(this.tabItemSubject.getValue());
    this.setSelectedTab(this.tabItemSubject.getValue()?.length - 1);
  }
  getComponent(tab: ITab): any {
    if (tab.componentType) {
      const module = tab.moduleFactory.create(tab.injector);
      const r = module.componentFactoryResolver;
      const cmpFactory = r.resolveComponentFactory(tab.componentType);
      const componentRef = cmpFactory.create(tab.injector);
      return componentRef.instance;
    }
    return null;
  }
  gettab(index: number) {
    return this.tabItemSubject.getValue()[index];
  }
  setSelectedTab(index: number) {
    let tab = this.gettab(index);
    this.selectedTabId = tab?.id;
    if (!tab) tab = this.gettab(this.tabItemSubject.getValue()?.length - 1);
    this.tabItemSubject.getValue()?.forEach((_tab) => {
      _tab.active = tab === _tab;
    });
    if (tab) this.tabItemActive.next(tab.id);
  }
  getActiveTabIndex() {
    let tabIndex: number = 0;
    let index = this.tabItemSubject.getValue().findIndex((it) => it.active);
    if (index != -1) tabIndex = index;
    return tabIndex;
  }

  getActiveTab() {
    return this.gettab(this.getActiveTabIndex());
  }
  closeActiveTab() {
    this.close(this.getActiveTabIndex());
  }
  canCloasTab(index: number) {
    if (this.tabItemOnCloseableIds.some((x) => x === this.tabItemSubject.getValue()[index].id)) {
      this.tabItemOnClosing.next(this.tabItemSubject.getValue()[index].id);
      this.tabItemOnCanClosing.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x && index < this.tabItemSubject.getValue().length && x === this.tabItemSubject.getValue()[index].id) {
          this.tabItemSubject.getValue().splice(index, 1);
          this.tabItemSubject.next(this.tabItemSubject.getValue());
          this.setSelectedTab(index > 0 ? index - 1 : 0);
        } else this.setSelectedTab(this.tabItemSubject.getValue().length - 1);
      });
      return false;
    } else return true;
  }
  close(index: number) {
    if (this.tabItemOnCloseableIds.some((x) => x === this.tabItemSubject.getValue()[index].id)) {
      this.tabItemOnClosing.next(this.tabItemSubject.getValue()[index].id);
      this.tabItemOnCanClosing.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x && index < this.tabItemSubject.getValue().length && x === this.tabItemSubject.getValue()[index].id) {
          this.tabItemSubject.getValue().splice(index, 1);
          this.tabItemSubject.next(this.tabItemSubject.getValue());
          this.setSelectedTab(index > 0 ? index - 1 : 0);
        } else this.setSelectedTab(this.tabItemSubject.getValue().length - 1);
      });
    } else {
      this.tabItemSubject.getValue().splice(index, 1);
      this.tabItemSubject.next(this.tabItemSubject.getValue());
      this.setSelectedTab(index > 0 ? index - 1 : 0);
    }
  }
  refresh() {
    let index = this.getActiveTabIndex();
    this.tabItemSubject.next(this.tabItemSubject.getValue());
    this.setSelectedTab(index);
  }
  closeById(id: string) {
    const index = this.tabItemSubject.getValue().findIndex((tab) => tab.id === id);
    if (index >= 0) {
      this.tabItemSubject.getValue().splice(index, 1);
      this.tabItemSubject.next(this.tabItemSubject.getValue());
      this.setSelectedTab(index > 0 ? index - 1 : 0);
    }
  }

  gettabById(id: string) {
    const index = this.tabItemSubject.getValue().findIndex((tab) => tab.id === id);
    return this.tabItemSubject.getValue()[index];
  }

  closeAll() {
    let length = this.tabItemSubject.getValue().length;
    let flag: boolean = true;
    let cloaseableIndex: number = 0;
    for (let i = 0; i < length - 1; i++) {
      if (flag && !this.canCloasTab(i)) {
        flag = false;
        cloaseableIndex = i;
      } else this.close(i);
    }
    if (flag) {
      this.tabItemSubject.getValue().splice(0, length - 0);
      this.tabItemSubject.next(this.tabItemSubject.getValue());
      this.tabItemonCloseAll.next(true);
    }
    if (this.tabItemSubject.getValue().length > 0)
      this.sts.showDialog(
        this.translate.instant("ClientApp.Projects.FrameWorkShell.Tabular.OneSomeTabsNotClosed"),
        this.translate.instant("ClientApp.Projects.FrameWorkShell.Tabular.Warning")
      );
  }
  closeAllForce() {
    let length = this.tabItemSubject.getValue().length;
    this.tabItemSubject.getValue().splice(0, length - 0);
    this.tabItemSubject.next(this.tabItemSubject.getValue());
    this.tabItemonCloseAll.next(true);
  }
  changeActiveTabIndex() {
    const getActiveIndex = this.getActiveTabIndex();
    const getMaxLength = this.tabItemSubject?.getValue()?.length - 1;
    if (getActiveIndex < getMaxLength) {
      this.setSelectedTab(getActiveIndex + 1);
    } else {
      this.setSelectedTab(0);
    }
  }
}
